export default {
    path: '/routers',
    name: 'Routers',
    component: () => import(/* webpackChunkName: "routers" */ '../../views/routers/routers.vue')
}